import { useState, useEffect, useContext } from 'react';
import { Typography, Grid, Box, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useApolloClient } from '@apollo/client';
import styles from './styles';
import useLocalStorage, { removeLocalStorage, setCode } from '../../hooks/useLocalStorage';
import { getCookie } from '../../hooks/useCookie';
import RootContext from '../../../util/root.context';
import { removeTariff } from './Broadband.util';

const BroadbandPrequalResult = props => {
  const theme = useTheme();
  const localStore = useLocalStorage();
  const { getLocalStorage } = localStore;
  const [address, setAddress] = useState('');
  const graphql = useApolloClient();
  const { state: rootState, dispatch } = useContext(RootContext);
  useEffect(() => {
    let Address = '';
    let prequalResult = JSON.parse(getLocalStorage('PREQUAL_RESULT'));
    if (getCookie('cart_Type') && getCookie('cart_Type') === 'CHANGE_OFFER') {
      setCode('CO');
      prequalResult = JSON.parse(getLocalStorage('PREQUAL_RESULT'));
    }
    if (prequalResult?.fullAddress && !getCookie('ECC_ADDRESS')) {
      Address = `${prequalResult?.fullAddress}`;

      if (prequalResult?.eircode) Address = `${Address}, ${prequalResult?.eircode}`;

      setAddress(Address);
    } else if (getCookie('ECC_ADDRESS')) {
      setAddress(getCookie('ECC_ADDRESS'));
    }
  }, [props.COEligibilityStatus]);

  /**
   * @name changeAddress - Remove the prequal result and get back to eircode input form
   */

  const changeAddress = async () => {
    if (props.changeOffer) return;
    props.setIsMBBJourney(false);
    props.setIsNBIJourney(false);
    props.setCurrentService('');
    props.setNBIMultiline(false);
    props.setIsR6NGB(false);
    try {
      const offerId = await rootState.cart?.offers?.filter(
        offer =>
          offer.baseOffer?.serviceGroup === 'DUALPLAY' || offer.baseOffer?.serviceGroup === 'MBB'
      )[0]?.id;
      if (rootState.cart?.offers.length > 0 && offerId) {
        // if(offerId){
        const data = await removeTariff(graphql, offerId);
        if (data != null && !data.error) {
          dispatch({ type: 'SET_CART', payload: data });
          removeLocalStorage('PREQUAL_RESULT');
          // setCode('R6');
          // removeLocalStorage('PREQUAL_ADDRESS');
          localStorage.clear();
          props.setIsPrequaled(false);
          props.setPrequalStatus(false);
          props.setErrorModalOccurence(0);
          props.setPrequalByPhone(false);
        }
      } else {
        removeLocalStorage('PREQUAL_RESULT');
        // setCode('R6');
        // removeLocalStorage('PREQUAL_ADDRESS');
        localStorage.clear();
        props.openAccountCheck.disable();
        props.setIsPrequaled(false);
        props.setPrequalStatus(false);
        props.setErrorModalOccurence(0);
        props.setPrequalByPhone(false);
      }
      props.setFTTHinFuture(false);
      props.setShowPrequalTopTag(false);
    } catch (err) {
      console.error(err);
      localStorage.clear();
      props.setIsPrequaled(false);
      props.setPrequalStatus(false);
      props.setErrorModalOccurence(0);
      props.setPrequalByPhone(false);
      props.setFTTHinFuture(false);
      props.setShowPrequalTopTag(false);
    }
  };
  return (
    <Grid container spacing={2} sx={styles(theme).prequalResultContainer}>
      <Grid item xs={12} md={12}>
        {getCookie('MYEIR_BB_ADDED') !== 'true' && (
          <Box sx={styles(theme).prequalTitleContainer}>
            {props.prequalByPhone ? (
              <Typography
                component='p'
                variant='h4'
                color={theme.palette.secondary.mobileActiveToggleBackground}
                sx={styles(theme).prequalAddress}
                dangerouslySetInnerHTML={{
                  __html: `Number: <strong>${props?.phoneNumber?.areaCode} ${props?.phoneNumber?.phoneNumber}</strong>`,
                }}
              />
            ) : (
              <Typography
                component='p'
                variant='h4'
                color={theme.palette.secondary.mobileActiveToggleBackground}
                sx={styles(theme).prequalAddress}
              >
                {address}
              </Typography>
            )}
          </Box>
        )}
      </Grid>
      {!props.changeOffer && props.COEligibilityStatus !== 'ECC' && (
        <Grid item xs={12} md={12} sx={{ zIndex: 1, textAlign: 'center' }}>
          {props.prequalByPhone ? (
            // eslint-disable-next-line
            <Link
              variant='body2'
              color={theme.palette.secondary.mobileActiveToggleBackground}
              onClick={() => {
                props.changePhoneNumber();
              }}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: theme.palette.secondary.mobileActiveToggleBackground,
              }}
            >
              Change phone number »
            </Link>
          ) : (
            // eslint-disable-next-line
            <Link
              variant='body2'
              color={theme.palette.primary.buttonColor}
              href=''
              onClick={() => {
                changeAddress();
              }}
              onKeyDown={e => {
                if ((e.shiftKey && e.key === 'Tab') || e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  changeAddress();
                  const header = document.getElementById('eir-header');
                  if (!header) return;
                  const allChildren = header.querySelectorAll('*');
                  allChildren.forEach(el => {
                    el.removeAttribute('tabindex');
                    el.removeAttribute('aria-hidden');
                  });
                }
              }}
              data-focus-bg='white'
              aria-label='change address'
              sx={{
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: theme.palette.primary.buttonColor,
              }}
            >
              Change address »
            </Link>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default BroadbandPrequalResult;
